import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS } from "@/lib/siteData";

export const CtaBand = () => {
  return (
    <section data-testid="cta-band" className="bg-green-800 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-15"
        style={{
          backgroundImage:
            "radial-gradient(circle at 15% 20%, rgba(255,255,255,0.5), transparent 40%), radial-gradient(circle at 85% 80%, rgba(74,222,128,0.6), transparent 45%)",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-center text-white">
        <h2
          data-testid="cta-band-headline"
          className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Need Help With Your Pond or Garden?
        </h2>
        <p className="mt-4 text-lg text-green-50/90 max-w-2xl mx-auto">
          Contact us today for a friendly chat about your project.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
          <a href={`tel:${BUSINESS.phoneTel}`} data-testid="cta-band-call-link">
            <Button
              size="lg"
              className="bg-white text-green-800 hover:bg-green-50 rounded-full px-8 py-6 text-base font-semibold"
            >
              <Phone className="w-5 h-5 mr-2" />
              Call {BUSINESS.phone}
            </Button>
          </a>
          <a href="#contact" data-testid="cta-band-quote-link">
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white/80 bg-transparent hover:bg-white hover:text-green-800 text-white rounded-full px-8 py-6 text-base font-semibold group"
            >
              Get in Touch
              <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
